import { render, staticRenderFns } from "./SellerBalance.vue?vue&type=template&id=884d4d54&scoped=true"
import script from "./SellerBalance.vue?vue&type=script&lang=js"
export * from "./SellerBalance.vue?vue&type=script&lang=js"
import style0 from "./SellerBalance.vue?vue&type=style&index=0&id=884d4d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884d4d54",
  null
  
)

export default component.exports